import { tokens } from 'src/design-system';
import { commonStyleSheet } from 'src/Library/CommonStyles';

export const styles = {
  ...commonStyleSheet,
  main: {
    minHeight: 600,
    marginBottom: 50,
    backgroundColor: '#FFF',
    height: '100%',
    width: '100%',
  },
  reference: {
    ...commonStyleSheet.flexRow,
    padding: tokens.spacing.ms,
    borderBottom: '1px solid #F1EEE7',
    borderRadius: `0 ${tokens.radius.md}px ${tokens.radius.md}px 0`,
    backgroundColor: '#FCFAF4',
    justifyContent: 'space-between',
  },
  referenceValue: {
    fontSize: tokens.fontSize.small,
    color: tokens.colors.text,
    fontWeight: tokens.fontWeight.semibold,
  },
  referenceTitle: {
    fontSize: tokens.fontSize.small,
    color: '#666666',
  },
  referenceList: {
  },
  mainDiv: {},
  trackingTitle: {
    fontSize: tokens.fontSize.h3,
    padding: tokens.spacing.md,
    paddingBottom: tokens.spacing.xs,
    fontWeight: 'bold',
    color: '#444444',
    fontFamily: 'Open Sans',
  },
  hr: {
    // width: '98%',
    height: 1.5,
    border: `1px solid ${tokens.colors.border}`,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '60px',
    paddingLeft: tokens.spacing.md,
    backgroundColor: '#FAF6EF',
  },
  referenceNumber: {
    fontSize: tokens.fontSize.h2,
    fontWeight: 'bold',
    color: '#444444',
    fontFamily: 'Open Sans',
  },
  trackingBox: {
    width: '98%',
    marginTop: tokens.spacing.md,
    marginLeft: 10,
    backgroundColor: tokens.colors.bgWhite,
    border: `1px solid ${tokens.colors.border}`,
    borderRadius: 5,
    marginBottom: 50,
  },
  line: {
    borderBottom: '1px solid #D9D9D9',
    opacity: 0.5,
    height: 1,
    width: '100%',
    marginTop: 6,
  },
  message: {
    height: 16,
    color: '#666666',
    fontFamily: 'Open Sans',
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    letterSpacing: 0,
    margin: tokens.spacing.lg,
  },
  contentBox: {
    width: '99%',
    margin: `${tokens.spacing.lg}px ${tokens.spacing.ms}px`,
  },
  contentTitle: {
    color: tokens.colors.text,
    fontFamily: 'Open Sans',
    fontSize: tokens.fontSize.h3,
    fontWeight: 'bold',
    letterSpacing: 0,
  },
  title: {
    color: '#666666',
    lineHeight: '14px',
    marginLeft: tokens.spacing.ms,
    fontSize: tokens.fontSize.small,
    minWidth: 120,
  },
  value: {
    color: tokens.colors.text,
    marginLeft: tokens.spacing.ms,
    fontSize: tokens.fontSize.small,
    lineHeight: '14px',
    fontWeight: tokens.fontWeight.semibold,
  },
  na: {
    color: '#999999',
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
    letterSpacing: 0,
    lineHeight: '12px',
    width: '50%',
    marginLeft: tokens.spacing.md,
  },
  contentRow: {
    ...commonStyleSheet.flexRow,
    margin: `${tokens.spacing.md}px ${tokens.spacing.ms}px`,
    alignItems: 'flex-start',
  },
  companyLabelText: {
    marginLeft: 10,
    fontWeight: tokens.fontWeight.bold,
    color: tokens.colors.text,
  },
  delinkContainersCommon: {
    marginRight: 15,
    fontSize: tokens.fontSize.small,
  },
  delinkContainersEnabled: {
    color: tokens.colors.primary,
    cursor: 'pointer',
  },
  delinkContainersDisabled: {
    color: '#d9d9d9',
    cursor: 'not-allowed',
  },
  showMoreText: {
    color: tokens.colors.primary,
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    cursor: 'pointer',
    marginLeft: tokens.spacing.ms,
  },
  referenceNumberText: {
    marginLeft: 10,
    fontWeight: 600,
    background: '#0E5AA11A',
    color: '#1890FF',
    borderRadius: '4px',
    padding: '4px 8px',
  },
  subHeaderContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 12,
  },
  subHeaderTitle: {
    fontSize: 12,
    fontWeight: 600,
  },
};
